/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PatientModelEditorViewModel } from '../models/patient-model-editor-view-model';
import { PatientDetailsModel } from '../models/patient-details-model';
import { PatientAuditNoteQueryResponseViewModel } from '../models/patient-audit-note-query-response-view-model';
import { PatientAuditNoteModel } from '../models/patient-audit-note-model';
import { Blob } from '../models/blob';
import { PatientListModelQueryResponseViewModel } from '../models/patient-list-model-query-response-view-model';
import { IncomingPatientSearchModule } from '../models/incoming-patient-search-module';
import { PatientContactInfoModelEditorModel } from '../models/patient-contact-info-model-editor-model';
import { PatientEmergencyContactInfoEditorViewModel } from '../models/patient-emergency-contact-info-editor-view-model';
import { PatientLocationDetailHistoryModel } from '../models/patient-location-detail-history-model';
import { PatientMedicalDetailHistoryModel } from '../models/patient-medical-detail-history-model';
import { PatientListModelResponseViewModel } from '../models/patient-list-model-response-view-model';
import { PatientQueryModel } from '../models/patient-query-model';
import { PatientRegistrationModel } from '../models/patient-registration-model';
import { PatientIdentifierModelViewModel } from '../models/patient-identifier-model-view-model';
import { PatientTravelCompanionModelViewModel } from '../models/patient-travel-companion-model-view-model';
import { PatientTravelCompanionRemoveModel } from '../models/patient-travel-companion-remove-model';
import { PatientDispositionModel } from '../models/patient-disposition-model';
import { PatientIdentifierModel } from '../models/patient-identifier-model';
import { ImageUploadResultModel } from '../models/image-upload-result-model';
import { ImageModel } from '../models/image-model';
import { PatientContactInfoModel } from '../models/patient-contact-info-model';
import { PatientEmergencyContactModel } from '../models/patient-emergency-contact-model';
import { PatientMedicalDetailsModel } from '../models/patient-medical-details-model';
import { PatientTravelCompanionSaveModel } from '../models/patient-travel-companion-save-model';
import { PatientUploadResultModel } from '../models/patient-upload-result-model';
@Injectable({
  providedIn: 'root',
})
class PatientService extends __BaseService {
  static readonly GetPath = '/view/jpats/patient';
  static readonly SavePath = '/view/jpats/patient';
  static readonly GetByKeyPath = '/view/jpats/patient/{patientKey}';
  static readonly GetPatientAuditNotesPath = '/view/jpats/patient/{patientKey}/PatientAuditNotes';
  static readonly SavePatientAuditNotePath = '/view/jpats/patient/{patientKey}/SavePatientAuditNote';
  static readonly DeletePatientAuditNotePath = '/view/jpats/patient/{patientKey}/DeletePatientAuditNote';
  static readonly DownloadPatientHistoryReportPath = '/view/jpats/patient/{patientKey}/DownloadPatientHistoryReport';
  static readonly GetPatientLockedPath = '/view/jpats/patient/{patientKey}/GetLocked';
  static readonly GetIncomingPatientsPath = '/view/jpats/patient/IncomingPatients';
  static readonly GetPatientContactInfoPath = '/view/jpats/patient/{patientKey}/PatientContactInformation';
  static readonly GetPatientEmergencyContactInfoPath = '/view/jpats/patient/{patientKey}/PatientEmergencyContactInfo';
  static readonly GetPatientLocationHistoryPath = '/view/jpats/patient/{patientKey}/PatientLocationHistory';
  static readonly GetPatientMedicalHistoryPath = '/view/jpats/patient/{patientKey}/PatientMedicalDetailsHistory';
  static readonly PatientsAsTravelCompanionsPath = '/view/jpats/patient/{patientKey}/PatientsAsTravelCompanions';
  static readonly QueryPath = '/view/jpats/patient/Query';
  static readonly RegisterIncomingPatientPath = '/view/jpats/patient/{patientKey}/RegisterIncomingPatient';
  static readonly RemoveIdentifierPath = '/view/jpats/patient/{patientKey}/RemoveIdentifier';
  static readonly RemoveTravelCompanionPath = '/view/jpats/patient/{patientKey}/RemoveTravelCompanion';
  static readonly SaveDispositionPath = '/view/jpats/patient/{patientKey}/SaveDisposition';
  static readonly SaveIdentifierPath = '/view/jpats/patient/{patientKey}/SaveIdentifier';
  static readonly SaveImagePath = '/view/jpats/patient/{patientKey}/SaveImage';
  static readonly SavePatientContactInformationPath = '/view/jpats/patient/{patientKey}/SavePatientContactInformation';
  static readonly SavePatientEmergencyContactInfoPath = '/view/jpats/patient/{patientKey}/SavePatientEmergencyContact';
  static readonly SavePatientMedicalDetailsPath = '/view/jpats/patient/{patientKey}/SavePatientMedicalDetails';
  static readonly SaveTravelCompanionPath = '/view/jpats/patient/{patientKey}/SaveTravelCompanion';
  static readonly UploadImagePath = '/view/jpats/patient/{patientKey}/UploadProfileImage';
  static readonly UploadPatientsPath = '/view/jpats/patient/UploadPatients';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  GetResponse(): __Observable<__StrictHttpResponse<PatientModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientModelEditorViewModel>;
      })
    );
  }
  /**
   * @return Success
   */
  Get(): __Observable<PatientModelEditorViewModel> {
    return this.GetResponse().pipe(
      __map(_r => _r.body as PatientModelEditorViewModel)
    );
  }

  /**
   * @param patientDetailsModel undefined
   * @return Success
   */
  SaveResponse(patientDetailsModel?: PatientDetailsModel): __Observable<__StrictHttpResponse<PatientModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = patientDetailsModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientModelEditorViewModel>;
      })
    );
  }
  /**
   * @param patientDetailsModel undefined
   * @return Success
   */
  Save(patientDetailsModel?: PatientDetailsModel): __Observable<PatientModelEditorViewModel> {
    return this.SaveResponse(patientDetailsModel).pipe(
      __map(_r => _r.body as PatientModelEditorViewModel)
    );
  }

  /**
   * @param patientKey undefined
   * @return Success
   */
  GetByKeyResponse(patientKey: string): __Observable<__StrictHttpResponse<PatientModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${patientKey}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientModelEditorViewModel>;
      })
    );
  }
  /**
   * @param patientKey undefined
   * @return Success
   */
  GetByKey(patientKey: string): __Observable<PatientModelEditorViewModel> {
    return this.GetByKeyResponse(patientKey).pipe(
      __map(_r => _r.body as PatientModelEditorViewModel)
    );
  }

  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientAuditNotesResponse(patientKey: string): __Observable<__StrictHttpResponse<PatientAuditNoteQueryResponseViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${patientKey}/PatientAuditNotes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientAuditNoteQueryResponseViewModel>;
      })
    );
  }
  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientAuditNotes(patientKey: string): __Observable<PatientAuditNoteQueryResponseViewModel> {
    return this.GetPatientAuditNotesResponse(patientKey).pipe(
      __map(_r => _r.body as PatientAuditNoteQueryResponseViewModel)
    );
  }

  /**
   * @param params The `PatientService.SavePatientAuditNoteParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientAuditNoteModel`:
   *
   * @return Success
   */
  SavePatientAuditNoteResponse(params: PatientService.SavePatientAuditNoteParams): __Observable<__StrictHttpResponse<PatientAuditNoteModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientAuditNoteModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/SavePatientAuditNote`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientAuditNoteModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.SavePatientAuditNoteParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientAuditNoteModel`:
   *
   * @return Success
   */
  SavePatientAuditNote(params: PatientService.SavePatientAuditNoteParams): __Observable<PatientAuditNoteModel> {
    return this.SavePatientAuditNoteResponse(params).pipe(
      __map(_r => _r.body as PatientAuditNoteModel)
    );
  }

  /**
   * @param params The `PatientService.DeletePatientAuditNoteParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientAuditNoteModel`:
   *
   * @return Success
   */
  DeletePatientAuditNoteResponse(params: PatientService.DeletePatientAuditNoteParams): __Observable<__StrictHttpResponse<PatientAuditNoteModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientAuditNoteModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/DeletePatientAuditNote`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientAuditNoteModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.DeletePatientAuditNoteParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientAuditNoteModel`:
   *
   * @return Success
   */
  DeletePatientAuditNote(params: PatientService.DeletePatientAuditNoteParams): __Observable<PatientAuditNoteModel> {
    return this.DeletePatientAuditNoteResponse(params).pipe(
      __map(_r => _r.body as PatientAuditNoteModel)
    );
  }

  /**
   * @param patientKey undefined
   * @return Success
   */
  DownloadPatientHistoryReportResponse(patientKey: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${patientKey}/DownloadPatientHistoryReport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param patientKey undefined
   * @return Success
   */
  DownloadPatientHistoryReport(patientKey: string): __Observable<Blob> {
    return this.DownloadPatientHistoryReportResponse(patientKey).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientLockedResponse(patientKey: string): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${patientKey}/GetLocked`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientLocked(patientKey: string): __Observable<boolean> {
    return this.GetPatientLockedResponse(patientKey).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param incomingPatientSearch undefined
   * @return Success
   */
  GetIncomingPatientsResponse(incomingPatientSearch?: IncomingPatientSearchModule): __Observable<__StrictHttpResponse<PatientListModelQueryResponseViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = incomingPatientSearch;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/IncomingPatients`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientListModelQueryResponseViewModel>;
      })
    );
  }
  /**
   * @param incomingPatientSearch undefined
   * @return Success
   */
  GetIncomingPatients(incomingPatientSearch?: IncomingPatientSearchModule): __Observable<PatientListModelQueryResponseViewModel> {
    return this.GetIncomingPatientsResponse(incomingPatientSearch).pipe(
      __map(_r => _r.body as PatientListModelQueryResponseViewModel)
    );
  }

  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientContactInfoResponse(patientKey: string): __Observable<__StrictHttpResponse<PatientContactInfoModelEditorModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${patientKey}/PatientContactInformation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientContactInfoModelEditorModel>;
      })
    );
  }
  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientContactInfo(patientKey: string): __Observable<PatientContactInfoModelEditorModel> {
    return this.GetPatientContactInfoResponse(patientKey).pipe(
      __map(_r => _r.body as PatientContactInfoModelEditorModel)
    );
  }

  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientEmergencyContactInfoResponse(patientKey: string): __Observable<__StrictHttpResponse<PatientEmergencyContactInfoEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${patientKey}/PatientEmergencyContactInfo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientEmergencyContactInfoEditorViewModel>;
      })
    );
  }
  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientEmergencyContactInfo(patientKey: string): __Observable<PatientEmergencyContactInfoEditorViewModel> {
    return this.GetPatientEmergencyContactInfoResponse(patientKey).pipe(
      __map(_r => _r.body as PatientEmergencyContactInfoEditorViewModel)
    );
  }

  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientLocationHistoryResponse(patientKey: string): __Observable<__StrictHttpResponse<PatientLocationDetailHistoryModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${patientKey}/PatientLocationHistory`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientLocationDetailHistoryModel>;
      })
    );
  }
  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientLocationHistory(patientKey: string): __Observable<PatientLocationDetailHistoryModel> {
    return this.GetPatientLocationHistoryResponse(patientKey).pipe(
      __map(_r => _r.body as PatientLocationDetailHistoryModel)
    );
  }

  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientMedicalHistoryResponse(patientKey: string): __Observable<__StrictHttpResponse<PatientMedicalDetailHistoryModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${patientKey}/PatientMedicalDetailsHistory`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientMedicalDetailHistoryModel>;
      })
    );
  }
  /**
   * @param patientKey undefined
   * @return Success
   */
  GetPatientMedicalHistory(patientKey: string): __Observable<PatientMedicalDetailHistoryModel> {
    return this.GetPatientMedicalHistoryResponse(patientKey).pipe(
      __map(_r => _r.body as PatientMedicalDetailHistoryModel)
    );
  }

  /**
   * @param params The `PatientService.PatientsAsTravelCompanionsParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `UnlockLocation`:
   *
   * - `UnaccompaniedMinor`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `SocialSecurityNumber`:
   *
   * - `Skip`:
   *
   * - `SearchAllLocations`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `OriginatingLocationZip`:
   *
   * - `OriginatingLocationState`:
   *
   * - `OriginatingLocationCity`:
   *
   * - `OriginatingLocationAddress`:
   *
   * - `OriginatingLocation`:
   *
   * - `OriginatingFcc.MetadataKey`:
   *
   * - `OriginatingFcc.Key`:
   *
   * - `OriginatingFcc.Description`:
   *
   * - `OriginatingFcc.Active`:
   *
   * - `Operation.MetadataKey`:
   *
   * - `Operation.Key`:
   *
   * - `Operation.Description`:
   *
   * - `Operation.Active`:
   *
   * - `Manifest`:
   *
   * - `Location.MetadataKey`:
   *
   * - `Location.Key`:
   *
   * - `Location.Description`:
   *
   * - `Location.Active`:
   *
   * - `LastName`:
   *
   * - `IdentityNumber`:
   *
   * - `HealthStatus.MetadataKey`:
   *
   * - `HealthStatus.Key`:
   *
   * - `HealthStatus.Description`:
   *
   * - `HealthStatus.Active`:
   *
   * - `Gender.MetadataKey`:
   *
   * - `Gender.Key`:
   *
   * - `Gender.Description`:
   *
   * - `Gender.Active`:
   *
   * - `FromEMR`:
   *
   * - `ForExport`:
   *
   * - `FirstName`:
   *
   * - `Fcc.MetadataKey`:
   *
   * - `Fcc.Key`:
   *
   * - `Fcc.Description`:
   *
   * - `Fcc.Active`:
   *
   * - `DispositionDateStart`:
   *
   * - `DispositionDateEnd`:
   *
   * - `DispositionDate`:
   *
   * - `Disposition.MetadataKey`:
   *
   * - `Disposition.Key`:
   *
   * - `Disposition.Description`:
   *
   * - `Disposition.Active`:
   *
   * - `DischargeStartDate`:
   *
   * - `DischargeEndDate`:
   *
   * - `DestinationLocation.MetadataKey`:
   *
   * - `DestinationLocation.Key`:
   *
   * - `DestinationLocation.Description`:
   *
   * - `DestinationLocation.Active`:
   *
   * - `DestinationFcc.MetadataKey`:
   *
   * - `DestinationFcc.Key`:
   *
   * - `DestinationFcc.Description`:
   *
   * - `DestinationFcc.Active`:
   *
   * - `CriticalCareAirTransportTeam.MetadataKey`:
   *
   * - `CriticalCareAirTransportTeam.Key`:
   *
   * - `CriticalCareAirTransportTeam.Description`:
   *
   * - `CriticalCareAirTransportTeam.Active`:
   *
   * - `BirthDateStart`:
   *
   * - `BirthDateEnd`:
   *
   * - `BirthDate`:
   *
   * - `BedType.MetadataKey`:
   *
   * - `BedType.Key`:
   *
   * - `BedType.Description`:
   *
   * - `BedType.Active`:
   *
   * - `AgeQualifier`:
   *
   * - `Age`:
   *
   * @return Success
   */
  PatientsAsTravelCompanionsResponse(params: PatientService.PatientsAsTravelCompanionsParams): __Observable<__StrictHttpResponse<PatientListModelQueryResponseViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.UnlockLocation != null) __params = __params.set('UnlockLocation', params.UnlockLocation.toString());
    if (params.UnaccompaniedMinor != null) __params = __params.set('UnaccompaniedMinor', params.UnaccompaniedMinor.toString());
    if (params.Take != null) __params = __params.set('Take', params.Take.toString());
    if (params.SortOrder != null) __params = __params.set('SortOrder', params.SortOrder.toString());
    if (params.SortBy != null) __params = __params.set('SortBy', params.SortBy.toString());
    if (params.SocialSecurityNumber != null) __params = __params.set('SocialSecurityNumber', params.SocialSecurityNumber.toString());
    if (params.Skip != null) __params = __params.set('Skip', params.Skip.toString());
    if (params.SearchAllLocations != null) __params = __params.set('SearchAllLocations', params.SearchAllLocations.toString());
    if (params.PageSize != null) __params = __params.set('PageSize', params.PageSize.toString());
    if (params.Page != null) __params = __params.set('Page', params.Page.toString());
    if (params.OriginatingLocationZip != null) __params = __params.set('OriginatingLocationZip', params.OriginatingLocationZip.toString());
    if (params.OriginatingLocationState != null) __params = __params.set('OriginatingLocationState', params.OriginatingLocationState.toString());
    if (params.OriginatingLocationCity != null) __params = __params.set('OriginatingLocationCity', params.OriginatingLocationCity.toString());
    if (params.OriginatingLocationAddress != null) __params = __params.set('OriginatingLocationAddress', params.OriginatingLocationAddress.toString());
    if (params.OriginatingLocation != null) __params = __params.set('OriginatingLocation', params.OriginatingLocation.toString());
    if (params.OriginatingFccMetadataKey != null) __params = __params.set('OriginatingFcc.MetadataKey', params.OriginatingFccMetadataKey.toString());
    if (params.OriginatingFccKey != null) __params = __params.set('OriginatingFcc.Key', params.OriginatingFccKey.toString());
    if (params.OriginatingFccDescription != null) __params = __params.set('OriginatingFcc.Description', params.OriginatingFccDescription.toString());
    if (params.OriginatingFccActive != null) __params = __params.set('OriginatingFcc.Active', params.OriginatingFccActive.toString());
    if (params.OperationMetadataKey != null) __params = __params.set('Operation.MetadataKey', params.OperationMetadataKey.toString());
    if (params.OperationKey != null) __params = __params.set('Operation.Key', params.OperationKey.toString());
    if (params.OperationDescription != null) __params = __params.set('Operation.Description', params.OperationDescription.toString());
    if (params.OperationActive != null) __params = __params.set('Operation.Active', params.OperationActive.toString());
    if (params.Manifest != null) __params = __params.set('Manifest', params.Manifest.toString());
    if (params.LocationMetadataKey != null) __params = __params.set('Location.MetadataKey', params.LocationMetadataKey.toString());
    if (params.LocationKey != null) __params = __params.set('Location.Key', params.LocationKey.toString());
    if (params.LocationDescription != null) __params = __params.set('Location.Description', params.LocationDescription.toString());
    if (params.LocationActive != null) __params = __params.set('Location.Active', params.LocationActive.toString());
    if (params.LastName != null) __params = __params.set('LastName', params.LastName.toString());
    if (params.IdentityNumber != null) __params = __params.set('IdentityNumber', params.IdentityNumber.toString());
    if (params.HealthStatusMetadataKey != null) __params = __params.set('HealthStatus.MetadataKey', params.HealthStatusMetadataKey.toString());
    if (params.HealthStatusKey != null) __params = __params.set('HealthStatus.Key', params.HealthStatusKey.toString());
    if (params.HealthStatusDescription != null) __params = __params.set('HealthStatus.Description', params.HealthStatusDescription.toString());
    if (params.HealthStatusActive != null) __params = __params.set('HealthStatus.Active', params.HealthStatusActive.toString());
    if (params.GenderMetadataKey != null) __params = __params.set('Gender.MetadataKey', params.GenderMetadataKey.toString());
    if (params.GenderKey != null) __params = __params.set('Gender.Key', params.GenderKey.toString());
    if (params.GenderDescription != null) __params = __params.set('Gender.Description', params.GenderDescription.toString());
    if (params.GenderActive != null) __params = __params.set('Gender.Active', params.GenderActive.toString());
    if (params.FromEMR != null) __params = __params.set('FromEMR', params.FromEMR.toString());
    if (params.ForExport != null) __params = __params.set('ForExport', params.ForExport.toString());
    if (params.FirstName != null) __params = __params.set('FirstName', params.FirstName.toString());
    if (params.FccMetadataKey != null) __params = __params.set('Fcc.MetadataKey', params.FccMetadataKey.toString());
    if (params.FccKey != null) __params = __params.set('Fcc.Key', params.FccKey.toString());
    if (params.FccDescription != null) __params = __params.set('Fcc.Description', params.FccDescription.toString());
    if (params.FccActive != null) __params = __params.set('Fcc.Active', params.FccActive.toString());
    if (params.DispositionDateStart != null) __params = __params.set('DispositionDateStart', params.DispositionDateStart.toString());
    if (params.DispositionDateEnd != null) __params = __params.set('DispositionDateEnd', params.DispositionDateEnd.toString());
    if (params.DispositionDate != null) __params = __params.set('DispositionDate', params.DispositionDate.toString());
    if (params.DispositionMetadataKey != null) __params = __params.set('Disposition.MetadataKey', params.DispositionMetadataKey.toString());
    if (params.DispositionKey != null) __params = __params.set('Disposition.Key', params.DispositionKey.toString());
    if (params.DispositionDescription != null) __params = __params.set('Disposition.Description', params.DispositionDescription.toString());
    if (params.DispositionActive != null) __params = __params.set('Disposition.Active', params.DispositionActive.toString());
    if (params.DischargeStartDate != null) __params = __params.set('DischargeStartDate', params.DischargeStartDate.toString());
    if (params.DischargeEndDate != null) __params = __params.set('DischargeEndDate', params.DischargeEndDate.toString());
    if (params.DestinationLocationMetadataKey != null) __params = __params.set('DestinationLocation.MetadataKey', params.DestinationLocationMetadataKey.toString());
    if (params.DestinationLocationKey != null) __params = __params.set('DestinationLocation.Key', params.DestinationLocationKey.toString());
    if (params.DestinationLocationDescription != null) __params = __params.set('DestinationLocation.Description', params.DestinationLocationDescription.toString());
    if (params.DestinationLocationActive != null) __params = __params.set('DestinationLocation.Active', params.DestinationLocationActive.toString());
    if (params.DestinationFccMetadataKey != null) __params = __params.set('DestinationFcc.MetadataKey', params.DestinationFccMetadataKey.toString());
    if (params.DestinationFccKey != null) __params = __params.set('DestinationFcc.Key', params.DestinationFccKey.toString());
    if (params.DestinationFccDescription != null) __params = __params.set('DestinationFcc.Description', params.DestinationFccDescription.toString());
    if (params.DestinationFccActive != null) __params = __params.set('DestinationFcc.Active', params.DestinationFccActive.toString());
    if (params.CriticalCareAirTransportTeamMetadataKey != null) __params = __params.set('CriticalCareAirTransportTeam.MetadataKey', params.CriticalCareAirTransportTeamMetadataKey.toString());
    if (params.CriticalCareAirTransportTeamKey != null) __params = __params.set('CriticalCareAirTransportTeam.Key', params.CriticalCareAirTransportTeamKey.toString());
    if (params.CriticalCareAirTransportTeamDescription != null) __params = __params.set('CriticalCareAirTransportTeam.Description', params.CriticalCareAirTransportTeamDescription.toString());
    if (params.CriticalCareAirTransportTeamActive != null) __params = __params.set('CriticalCareAirTransportTeam.Active', params.CriticalCareAirTransportTeamActive.toString());
    if (params.BirthDateStart != null) __params = __params.set('BirthDateStart', params.BirthDateStart.toString());
    if (params.BirthDateEnd != null) __params = __params.set('BirthDateEnd', params.BirthDateEnd.toString());
    if (params.BirthDate != null) __params = __params.set('BirthDate', params.BirthDate.toString());
    if (params.BedTypeMetadataKey != null) __params = __params.set('BedType.MetadataKey', params.BedTypeMetadataKey.toString());
    if (params.BedTypeKey != null) __params = __params.set('BedType.Key', params.BedTypeKey.toString());
    if (params.BedTypeDescription != null) __params = __params.set('BedType.Description', params.BedTypeDescription.toString());
    if (params.BedTypeActive != null) __params = __params.set('BedType.Active', params.BedTypeActive.toString());
    if (params.AgeQualifier != null) __params = __params.set('AgeQualifier', params.AgeQualifier.toString());
    if (params.Age != null) __params = __params.set('Age', params.Age.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/PatientsAsTravelCompanions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientListModelQueryResponseViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.PatientsAsTravelCompanionsParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `UnlockLocation`:
   *
   * - `UnaccompaniedMinor`:
   *
   * - `Take`:
   *
   * - `SortOrder`:
   *
   * - `SortBy`:
   *
   * - `SocialSecurityNumber`:
   *
   * - `Skip`:
   *
   * - `SearchAllLocations`:
   *
   * - `PageSize`:
   *
   * - `Page`:
   *
   * - `OriginatingLocationZip`:
   *
   * - `OriginatingLocationState`:
   *
   * - `OriginatingLocationCity`:
   *
   * - `OriginatingLocationAddress`:
   *
   * - `OriginatingLocation`:
   *
   * - `OriginatingFcc.MetadataKey`:
   *
   * - `OriginatingFcc.Key`:
   *
   * - `OriginatingFcc.Description`:
   *
   * - `OriginatingFcc.Active`:
   *
   * - `Operation.MetadataKey`:
   *
   * - `Operation.Key`:
   *
   * - `Operation.Description`:
   *
   * - `Operation.Active`:
   *
   * - `Manifest`:
   *
   * - `Location.MetadataKey`:
   *
   * - `Location.Key`:
   *
   * - `Location.Description`:
   *
   * - `Location.Active`:
   *
   * - `LastName`:
   *
   * - `IdentityNumber`:
   *
   * - `HealthStatus.MetadataKey`:
   *
   * - `HealthStatus.Key`:
   *
   * - `HealthStatus.Description`:
   *
   * - `HealthStatus.Active`:
   *
   * - `Gender.MetadataKey`:
   *
   * - `Gender.Key`:
   *
   * - `Gender.Description`:
   *
   * - `Gender.Active`:
   *
   * - `FromEMR`:
   *
   * - `ForExport`:
   *
   * - `FirstName`:
   *
   * - `Fcc.MetadataKey`:
   *
   * - `Fcc.Key`:
   *
   * - `Fcc.Description`:
   *
   * - `Fcc.Active`:
   *
   * - `DispositionDateStart`:
   *
   * - `DispositionDateEnd`:
   *
   * - `DispositionDate`:
   *
   * - `Disposition.MetadataKey`:
   *
   * - `Disposition.Key`:
   *
   * - `Disposition.Description`:
   *
   * - `Disposition.Active`:
   *
   * - `DischargeStartDate`:
   *
   * - `DischargeEndDate`:
   *
   * - `DestinationLocation.MetadataKey`:
   *
   * - `DestinationLocation.Key`:
   *
   * - `DestinationLocation.Description`:
   *
   * - `DestinationLocation.Active`:
   *
   * - `DestinationFcc.MetadataKey`:
   *
   * - `DestinationFcc.Key`:
   *
   * - `DestinationFcc.Description`:
   *
   * - `DestinationFcc.Active`:
   *
   * - `CriticalCareAirTransportTeam.MetadataKey`:
   *
   * - `CriticalCareAirTransportTeam.Key`:
   *
   * - `CriticalCareAirTransportTeam.Description`:
   *
   * - `CriticalCareAirTransportTeam.Active`:
   *
   * - `BirthDateStart`:
   *
   * - `BirthDateEnd`:
   *
   * - `BirthDate`:
   *
   * - `BedType.MetadataKey`:
   *
   * - `BedType.Key`:
   *
   * - `BedType.Description`:
   *
   * - `BedType.Active`:
   *
   * - `AgeQualifier`:
   *
   * - `Age`:
   *
   * @return Success
   */
  PatientsAsTravelCompanions(params: PatientService.PatientsAsTravelCompanionsParams): __Observable<PatientListModelQueryResponseViewModel> {
    return this.PatientsAsTravelCompanionsResponse(params).pipe(
      __map(_r => _r.body as PatientListModelQueryResponseViewModel)
    );
  }

  /**
   * @param patientQueryModel undefined
   * @return Success
   */
  QueryResponse(patientQueryModel?: PatientQueryModel): __Observable<__StrictHttpResponse<PatientListModelResponseViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = patientQueryModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/Query`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientListModelResponseViewModel>;
      })
    );
  }
  /**
   * @param patientQueryModel undefined
   * @return Success
   */
  Query(patientQueryModel?: PatientQueryModel): __Observable<PatientListModelResponseViewModel> {
    return this.QueryResponse(patientQueryModel).pipe(
      __map(_r => _r.body as PatientListModelResponseViewModel)
    );
  }

  /**
   * @param params The `PatientService.RegisterIncomingPatientParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientRegistrationModel`:
   *
   * @return Success
   */
  RegisterIncomingPatientResponse(params: PatientService.RegisterIncomingPatientParams): __Observable<__StrictHttpResponse<PatientModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientRegistrationModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/RegisterIncomingPatient`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.RegisterIncomingPatientParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientRegistrationModel`:
   *
   * @return Success
   */
  RegisterIncomingPatient(params: PatientService.RegisterIncomingPatientParams): __Observable<PatientModelEditorViewModel> {
    return this.RegisterIncomingPatientResponse(params).pipe(
      __map(_r => _r.body as PatientModelEditorViewModel)
    );
  }

  /**
   * @param params The `PatientService.RemoveIdentifierParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `MetadataKey`:
   *
   * - `HashCode`:
   *
   * @return Success
   */
  RemoveIdentifierResponse(params: PatientService.RemoveIdentifierParams): __Observable<__StrictHttpResponse<PatientIdentifierModelViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.MetadataKey != null) __params = __params.set('MetadataKey', params.MetadataKey.toString());
    if (params.HashCode != null) __params = __params.set('HashCode', params.HashCode.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/RemoveIdentifier`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientIdentifierModelViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.RemoveIdentifierParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `MetadataKey`:
   *
   * - `HashCode`:
   *
   * @return Success
   */
  RemoveIdentifier(params: PatientService.RemoveIdentifierParams): __Observable<PatientIdentifierModelViewModel> {
    return this.RemoveIdentifierResponse(params).pipe(
      __map(_r => _r.body as PatientIdentifierModelViewModel)
    );
  }

  /**
   * @param params The `PatientService.RemoveTravelCompanionParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `travelCompanionRemoveModel`:
   *
   * @return Success
   */
  RemoveTravelCompanionResponse(params: PatientService.RemoveTravelCompanionParams): __Observable<__StrictHttpResponse<PatientTravelCompanionModelViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.travelCompanionRemoveModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/RemoveTravelCompanion`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientTravelCompanionModelViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.RemoveTravelCompanionParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `travelCompanionRemoveModel`:
   *
   * @return Success
   */
  RemoveTravelCompanion(params: PatientService.RemoveTravelCompanionParams): __Observable<PatientTravelCompanionModelViewModel> {
    return this.RemoveTravelCompanionResponse(params).pipe(
      __map(_r => _r.body as PatientTravelCompanionModelViewModel)
    );
  }

  /**
   * @param params The `PatientService.SaveDispositionParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientDispositionModel`:
   *
   * @return Success
   */
  SaveDispositionResponse(params: PatientService.SaveDispositionParams): __Observable<__StrictHttpResponse<PatientModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientDispositionModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/SaveDisposition`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.SaveDispositionParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientDispositionModel`:
   *
   * @return Success
   */
  SaveDisposition(params: PatientService.SaveDispositionParams): __Observable<PatientModelEditorViewModel> {
    return this.SaveDispositionResponse(params).pipe(
      __map(_r => _r.body as PatientModelEditorViewModel)
    );
  }

  /**
   * @param params The `PatientService.SaveIdentifierParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `identifierModel`:
   *
   * @return Success
   */
  SaveIdentifierResponse(params: PatientService.SaveIdentifierParams): __Observable<__StrictHttpResponse<PatientIdentifierModelViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.identifierModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/SaveIdentifier`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientIdentifierModelViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.SaveIdentifierParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `identifierModel`:
   *
   * @return Success
   */
  SaveIdentifier(params: PatientService.SaveIdentifierParams): __Observable<PatientIdentifierModelViewModel> {
    return this.SaveIdentifierResponse(params).pipe(
      __map(_r => _r.body as PatientIdentifierModelViewModel)
    );
  }

  /**
   * @param params The `PatientService.SaveImageParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `image`:
   *
   * @return Success
   */
  SaveImageResponse(params: PatientService.SaveImageParams): __Observable<__StrictHttpResponse<ImageUploadResultModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.image;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/SaveImage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ImageUploadResultModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.SaveImageParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `image`:
   *
   * @return Success
   */
  SaveImage(params: PatientService.SaveImageParams): __Observable<ImageUploadResultModel> {
    return this.SaveImageResponse(params).pipe(
      __map(_r => _r.body as ImageUploadResultModel)
    );
  }

  /**
   * @param params The `PatientService.SavePatientContactInformationParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientContactInfoModel`:
   *
   * @return Success
   */
  SavePatientContactInformationResponse(params: PatientService.SavePatientContactInformationParams): __Observable<__StrictHttpResponse<PatientModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientContactInfoModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/SavePatientContactInformation`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.SavePatientContactInformationParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientContactInfoModel`:
   *
   * @return Success
   */
  SavePatientContactInformation(params: PatientService.SavePatientContactInformationParams): __Observable<PatientModelEditorViewModel> {
    return this.SavePatientContactInformationResponse(params).pipe(
      __map(_r => _r.body as PatientModelEditorViewModel)
    );
  }

  /**
   * @param params The `PatientService.SavePatientEmergencyContactInfoParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientContactInfoModel`:
   *
   * @return Success
   */
  SavePatientEmergencyContactInfoResponse(params: PatientService.SavePatientEmergencyContactInfoParams): __Observable<__StrictHttpResponse<PatientModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientContactInfoModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/SavePatientEmergencyContact`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.SavePatientEmergencyContactInfoParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientContactInfoModel`:
   *
   * @return Success
   */
  SavePatientEmergencyContactInfo(params: PatientService.SavePatientEmergencyContactInfoParams): __Observable<PatientModelEditorViewModel> {
    return this.SavePatientEmergencyContactInfoResponse(params).pipe(
      __map(_r => _r.body as PatientModelEditorViewModel)
    );
  }

  /**
   * @param params The `PatientService.SavePatientMedicalDetailsParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientModel`:
   *
   * @return Success
   */
  SavePatientMedicalDetailsResponse(params: PatientService.SavePatientMedicalDetailsParams): __Observable<__StrictHttpResponse<PatientModelEditorViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.patientModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/SavePatientMedicalDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientModelEditorViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.SavePatientMedicalDetailsParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `patientModel`:
   *
   * @return Success
   */
  SavePatientMedicalDetails(params: PatientService.SavePatientMedicalDetailsParams): __Observable<PatientModelEditorViewModel> {
    return this.SavePatientMedicalDetailsResponse(params).pipe(
      __map(_r => _r.body as PatientModelEditorViewModel)
    );
  }

  /**
   * @param params The `PatientService.SaveTravelCompanionParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `travelCompanionSaveModel`:
   *
   * @return Success
   */
  SaveTravelCompanionResponse(params: PatientService.SaveTravelCompanionParams): __Observable<__StrictHttpResponse<PatientTravelCompanionModelViewModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.travelCompanionSaveModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/SaveTravelCompanion`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientTravelCompanionModelViewModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.SaveTravelCompanionParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `travelCompanionSaveModel`:
   *
   * @return Success
   */
  SaveTravelCompanion(params: PatientService.SaveTravelCompanionParams): __Observable<PatientTravelCompanionModelViewModel> {
    return this.SaveTravelCompanionResponse(params).pipe(
      __map(_r => _r.body as PatientTravelCompanionModelViewModel)
    );
  }

  /**
   * @param params The `PatientService.UploadImageParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `files`:
   *
   * @return Success
   */
  UploadImageResponse(params: PatientService.UploadImageParams): __Observable<__StrictHttpResponse<ImageUploadResultModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;

    (params.files || []).forEach(val => {if (val != null) __formData.append('files', JSON.stringify(val))});
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/${params.patientKey}/UploadProfileImage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ImageUploadResultModel>;
      })
    );
  }
  /**
   * @param params The `PatientService.UploadImageParams` containing the following parameters:
   *
   * - `patientKey`:
   *
   * - `files`:
   *
   * @return Success
   */
  UploadImage(params: PatientService.UploadImageParams): __Observable<ImageUploadResultModel> {
    return this.UploadImageResponse(params).pipe(
      __map(_r => _r.body as ImageUploadResultModel)
    );
  }

  /**
   * @param patients undefined
   * @return Success
   */
  UploadPatientsResponse(patients?: Array<PatientDetailsModel>): __Observable<__StrictHttpResponse<PatientUploadResultModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = patients;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/jpats/patient/UploadPatients`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PatientUploadResultModel>;
      })
    );
  }
  /**
   * @param patients undefined
   * @return Success
   */
  UploadPatients(patients?: Array<PatientDetailsModel>): __Observable<PatientUploadResultModel> {
    return this.UploadPatientsResponse(patients).pipe(
      __map(_r => _r.body as PatientUploadResultModel)
    );
  }
}

module PatientService {

  /**
   * Parameters for SavePatientAuditNote
   */
  export interface SavePatientAuditNoteParams {
    patientKey: string;
    patientAuditNoteModel?: PatientAuditNoteModel;
  }

  /**
   * Parameters for DeletePatientAuditNote
   */
  export interface DeletePatientAuditNoteParams {
    patientKey: string;
    patientAuditNoteModel?: PatientAuditNoteModel;
  }

  /**
   * Parameters for PatientsAsTravelCompanions
   */
  export interface PatientsAsTravelCompanionsParams {
    patientKey: string;
    UnlockLocation?: boolean;
    UnaccompaniedMinor?: boolean;
    Take?: number;
    SortOrder?: number;
    SortBy?: string;
    SocialSecurityNumber?: string;
    Skip?: number;
    SearchAllLocations?: boolean;
    PageSize?: number;
    Page?: number;
    OriginatingLocationZip?: string;
    OriginatingLocationState?: string;
    OriginatingLocationCity?: string;
    OriginatingLocationAddress?: string;
    OriginatingLocation?: string;
    OriginatingFccMetadataKey?: string;
    OriginatingFccKey?: string;
    OriginatingFccDescription?: string;
    OriginatingFccActive?: boolean;
    OperationMetadataKey?: string;
    OperationKey?: string;
    OperationDescription?: string;
    OperationActive?: boolean;
    Manifest?: string;
    LocationMetadataKey?: string;
    LocationKey?: string;
    LocationDescription?: string;
    LocationActive?: boolean;
    LastName?: string;
    IdentityNumber?: string;
    HealthStatusMetadataKey?: string;
    HealthStatusKey?: string;
    HealthStatusDescription?: string;
    HealthStatusActive?: boolean;
    GenderMetadataKey?: string;
    GenderKey?: string;
    GenderDescription?: string;
    GenderActive?: boolean;
    FromEMR?: boolean;
    ForExport?: boolean;
    FirstName?: string;
    FccMetadataKey?: string;
    FccKey?: string;
    FccDescription?: string;
    FccActive?: boolean;
    DispositionDateStart?: string;
    DispositionDateEnd?: string;
    DispositionDate?: string;
    DispositionMetadataKey?: string;
    DispositionKey?: string;
    DispositionDescription?: string;
    DispositionActive?: boolean;
    DischargeStartDate?: string;
    DischargeEndDate?: string;
    DestinationLocationMetadataKey?: string;
    DestinationLocationKey?: string;
    DestinationLocationDescription?: string;
    DestinationLocationActive?: boolean;
    DestinationFccMetadataKey?: string;
    DestinationFccKey?: string;
    DestinationFccDescription?: string;
    DestinationFccActive?: boolean;
    CriticalCareAirTransportTeamMetadataKey?: string;
    CriticalCareAirTransportTeamKey?: string;
    CriticalCareAirTransportTeamDescription?: string;
    CriticalCareAirTransportTeamActive?: boolean;
    BirthDateStart?: string;
    BirthDateEnd?: string;
    BirthDate?: string;
    BedTypeMetadataKey?: string;
    BedTypeKey?: string;
    BedTypeDescription?: string;
    BedTypeActive?: boolean;
    AgeQualifier?: string;
    Age?: number;
  }

  /**
   * Parameters for RegisterIncomingPatient
   */
  export interface RegisterIncomingPatientParams {
    patientKey: string;
    patientRegistrationModel?: PatientRegistrationModel;
  }

  /**
   * Parameters for RemoveIdentifier
   */
  export interface RemoveIdentifierParams {
    patientKey: string;
    MetadataKey?: string;
    HashCode?: number;
  }

  /**
   * Parameters for RemoveTravelCompanion
   */
  export interface RemoveTravelCompanionParams {
    patientKey: string;
    travelCompanionRemoveModel?: PatientTravelCompanionRemoveModel;
  }

  /**
   * Parameters for SaveDisposition
   */
  export interface SaveDispositionParams {
    patientKey: string;
    patientDispositionModel?: PatientDispositionModel;
  }

  /**
   * Parameters for SaveIdentifier
   */
  export interface SaveIdentifierParams {
    patientKey: string;
    identifierModel?: PatientIdentifierModel;
  }

  /**
   * Parameters for SaveImage
   */
  export interface SaveImageParams {
    patientKey: string;
    image?: ImageModel;
  }

  /**
   * Parameters for SavePatientContactInformation
   */
  export interface SavePatientContactInformationParams {
    patientKey: string;
    patientContactInfoModel?: PatientContactInfoModel;
  }

  /**
   * Parameters for SavePatientEmergencyContactInfo
   */
  export interface SavePatientEmergencyContactInfoParams {
    patientKey: string;
    patientContactInfoModel?: PatientEmergencyContactModel;
  }

  /**
   * Parameters for SavePatientMedicalDetails
   */
  export interface SavePatientMedicalDetailsParams {
    patientKey: string;
    patientModel?: PatientMedicalDetailsModel;
  }

  /**
   * Parameters for SaveTravelCompanion
   */
  export interface SaveTravelCompanionParams {
    patientKey: string;
    travelCompanionSaveModel?: PatientTravelCompanionSaveModel;
  }

  /**
   * Parameters for UploadImage
   */
  export interface UploadImageParams {
    patientKey: string;
    files?: Array<any>;
  }
}

export { PatientService }
